import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';
import type { AstrologerProfile } from '../types/professional';

interface UseAstrologerProfileResult {
  astrologerProfile: AstrologerProfile | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useAstrologerProfile(): UseAstrologerProfileResult {
  const { user } = useAuth();
  const [astrologerProfile, setAstrologerProfile] = useState<AstrologerProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = useCallback(async () => {
    if (!user) { setLoading(false); return; }
    const { data } = await supabase
      .from('astrologer_profiles')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle();
    setAstrologerProfile(data as AstrologerProfile | null);
    setLoading(false);
  }, [user?.id]);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  return { astrologerProfile, loading, refresh: fetchProfile };
}
